export default function List({ color = "#79778E" }) {
  return (

    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1756_4487)">
        <path d="M19.25 16H4.75C3.79 16 3 15.21 3 14.25V9.75C3 8.78 3.79 8 4.75 8H19.25C20.22 8 21 8.78 21 9.75V14.25C21 15.21 20.22 16 19.25 16ZM4.75 9.5C4.62 9.5 4.5 9.61 4.5 9.75V14.25C4.5 14.39 4.61 14.5 4.75 14.5H19.25C19.39 14.5 19.5 14.39 19.5 14.25V9.75C19.5 9.61 19.39 9.5 19.25 9.5H4.75Z" fill={color} />
        <path d="M20.25 20H3.75C3.34 20 3 19.66 3 19.25C3 18.84 3.34 18.5 3.75 18.5H20.25C20.66 18.5 21 18.84 21 19.25C21 19.66 20.66 20 20.25 20Z" fill={color} />
        <path d="M20.25 5.50977H3.75C3.34 5.50977 3 5.16977 3 4.75977C3 4.34977 3.34 4.00977 3.75 4.00977H20.25C20.66 4.00977 21 4.34977 21 4.75977C21 5.16977 20.66 5.50977 20.25 5.50977Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1756_4487">
          <rect width="2.4rem" height="2.4rem" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}